import glassWallSettings from 'services/configurator/glassWallSettings';
import IWall from 'components/interfaces/IWall';

const getGlassMaxLength = (maxWeight: number, wall: IWall): number => {
  const thickness = glassWallSettings.thickness / 1000;
  const density = window.CommonFunctions.GetGlassDensity(wall.glassType);
  const height = wall.openingHeight / 1000;
  return (maxWeight / (height * thickness * density)) * 1000;
};

const getGlassWeight = (length: number, wall: IWall): number => {
  const thickness = glassWallSettings.thickness / 1000;
  const density = window.CommonFunctions.GetGlassDensity(wall.glassType);
  const height = wall.openingHeight / 1000;
  return thickness * density * height * (length / 1000);
};

export { getGlassMaxLength, getGlassWeight };
